import { Component, Input, SimpleChanges, ViewEncapsulation, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { isNil } from 'lodash';
import { first } from 'rxjs/operators';
import { GetAddressPipe } from '@app/shared/pipes/get-address.pipe';
import { MeterDataService } from '@app/shared/services/api/meter-data.service';
import { AuthService } from '@app/shared/services/auth.service';
import { UserMunicipalitiesService } from '@app/shared/services/user-municipalities.service';
import { MeterDataStoreServiceDirective } from '@app/shared/services/store/meter-data-store.service';
import { MeterView } from '@app/shared/models/meter-data/meter-view';
import { MeterAlarm } from './../../../energy-guard/models/alarms';

@Component({
  selector: 'app-collapsible-row',
  templateUrl: './collapsible-row.component.html',
  styleUrls: ['./collapsible-row.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [GetAddressPipe],
})
export class CollapsibleRowComponent implements OnChanges {
  @Input() data: MeterView[] = [];
  @Input() energyGuardData!: MeterAlarm[keyof MeterAlarm];
  @Input() isMunicipalityLicensed?: boolean;

  public meterData?: MeterView;

  constructor(
    public meterDataStoreServiceDirective: MeterDataStoreServiceDirective,
    public authService: AuthService,
    private router: Router,
    private meterDataService: MeterDataService,
    private userMunicipalitiesService: UserMunicipalitiesService
  ) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['energyGuardData']) {
      this.data.forEach((a: MeterView) => {
        if (isNil(a.objectType)) {
          a.objectType = '';
        }
        a.meterAlarm = this.energyGuardData?.[a.guid];
      });
    }
    this.meterData = this.data?.[0];
  }

  public saveNotes(guid: string, note: string, obj: MeterView): void {
    const noteData = { guid: guid, notes: note };
    this.meterDataService
      .updateNotesById(noteData, this.userMunicipalitiesService.currentMunicipality.key)
      .pipe(first())
      .subscribe({
        next: () => {
          obj.isNoteUpdateSuccess = true;
        },
        error: () => {
          obj.isNoteUpdateSuccess = false;
        },
      });
  }

  public navigateToConsumptionPage(guid: string): void {
    const meterView: any = this.data.find((x) => x.guid === guid);

    this.router.navigate(['/verbrauch'], {
      queryParams: {
        connectionobjectnumber: meterView.connectionObjectNumber,
        guid: meterView.guid,
        returnroute: 'messdaten/energiedaten',
      },
      queryParamsHandling: 'merge',
    });
  }

  public getMeterTypeImage(code: string, deviceId: string): string {
    return this.meterDataStoreServiceDirective.getMeterTypeImage(code, deviceId);
  }

  public getEnergyTypeImage(name: string): string {
    return this.meterDataStoreServiceDirective.getEnergyTypeImage(name);
  }
}
